module.exports = __webpack_public_path__ + "img/pay-success.84b7d2a6.svg";